export class DiagnosisType {
  public static GENERAL = 'Diagnóstico Completo';
  public static SIMPLIFIED = 'Parâmetros CAN';
}
  


// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/model/diagnosis-type.ts